import { apiGet, apiPatch, apiPost } from '@/shared/utils/requestBuilder';
import type { ArbitroAdmin, CadastrarArbitroDto } from '@/types/arbitral/arbitroAdminTypes';

export const arbitrosAdminService = {
  listar: async (): Promise<ArbitroAdmin[]> => {
    const response = await apiGet('/admin/arbitral/arbitros');
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Erro ao listar árbitros' }));
      throw new Error(errorData.error || 'Erro ao listar árbitros');
    }
    const result = await response.json();
    return result.data.items;
  },

  cadastrar: async (data: CadastrarArbitroDto): Promise<ArbitroAdmin> => {
    const response = await apiPost('/admin/arbitral/arbitros', data);
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Erro ao cadastrar árbitro' }));
      throw new Error(errorData.error || 'Erro ao cadastrar árbitro');
    }
    const result = await response.json();
    return result.data;
  },

  definirStatus: async (id: string, ativo: boolean): Promise<ArbitroAdmin> => {
    const response = await apiPatch(`/admin/arbitral/arbitros/${id}/status`, { ativo });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Erro ao alterar status' }));
      throw new Error(errorData.error || 'Erro ao alterar status do árbitro');
    }
    const result = await response.json();
    return result.data;
  },
};
